import { filter } from 'lodash-es';
import * as screenLocation from '../constants/screenLocation';
export function isInAnnotationMode(state) {
    return state.annotation.nextAnnotation !== null;
}
export function getHeaderAnnotations(state) {
    return getVisibleAnnotations(state, screenLocation.HEADER);
}
export function getFooterAnnotations(state) {
    return getVisibleAnnotations(state, screenLocation.FOOTER);
}
export function getBodyAnnotations(state) {
    return getVisibleAnnotations(state, screenLocation.BODY);
}
export function getOverlayAnnotations(state) {
    return getVisibleAnnotations(state, screenLocation.OVERLAY);
}
export function isHighlighted(state, commentUUID) {
    return state.annotation.highlightAnnotation === commentUUID;
}
export function isDehighlighted(state, commentUUID) {
    return (state.annotation.highlightAnnotation !== null &&
        state.annotation.highlightAnnotation !== commentUUID);
}
export function isPulsing(state, commentUUID) {
    return state.screen.scrollingToAnnotation === commentUUID;
}
export function isMoveable(state, annotation) {
    if (!annotation.isSaved) {
        return true;
    }
    return state.annotation.isAnnotationMoveable[annotation.commentUUID];
}
function getVisibleAnnotations(state, screenArea) {
    if (state.comment.areVisible) {
        return filter(state.annotation.annotations, function (annotation) { return annotation.screenArea === screenArea; });
    }
    return [];
}
